import { api } from '../client/client.js';

function mapPromo(p) {
  return {
    id: p.id,
    code: p.code,
    name: p.name || '',
    type: p.type,
    clientDiscountType: p.discount_kind || 'FIXED',
    discountValue: p.discount_value != null ? String(p.discount_value) : '',
    freeDays: p.free_days != null ? String(p.free_days) : '',
    partnerReward: p.partner_reward != null ? String(p.partner_reward) : '',
    minServers: p.min_servers != null ? String(p.min_servers) : '',
    maxUses: p.max_uses != null ? String(p.max_uses) : '',
    validDays: p.valid_days != null ? String(p.valid_days) : '',
    creatorId: p.creator_telegram_id != null ? String(p.creator_telegram_id) : '',
    creatorName: p.creator_username || '',
    referrals: Number(p.uses) || 0,
    partnerEarned: Number(p.partner_earned) || 0,
    ownEarned: Number(p.own_earned) || 0,
    enabled: p.enabled,
    planId: p.plan_id != null ? Number(p.plan_id) : null,
    planName: p.plan_name || null,
    createdAt: p.created_at,
  };
}

export function listPromoCodes() {
  return api.get('/promocodes').then((rows) => (Array.isArray(rows) ? rows.map(mapPromo) : []));
}

export function createPromoCode(input) {
  return api.post('/promocodes', {
    code: input.code,
    name: input.name || null,
    type: input.type,
    discount_kind: input.clientDiscountType,
    discount_value: input.discountValue || null,
    free_days: input.freeDays || null,
    partner_reward: input.partnerReward || null,
    min_servers: input.minServers || null,
    max_uses: input.maxUses || null,
    valid_days: input.validDays || null,
    plan_id: input.planId || null,
    creator_id: input.creatorId || null,
    creator_username: input.creatorName || null,
  }).then(mapPromo);
}

export function regeneratePromoCode(id) {
  return api.post(`/promocodes/${id}/regenerate`).then(mapPromo);
}

export function revokePromoCode(id) {
  return api.post(`/promocodes/${id}/revoke`);
}

export function deletePromoCode(id) {
  return api.delete(`/promocodes/${id}`);
}
